export const GET_FULL_HOST_URL = window.location.protocol + '//' + window.location.host;
